import { I18n } from '@lingui/core';
import { t } from '@lingui/macro';

export enum CreateModalStep {
  DevicesAndMetrics,
  TimePeriod,
  FormatAndRecipients,
  Summary,
}

export const stepList = [
  CreateModalStep.DevicesAndMetrics,
  CreateModalStep.TimePeriod,
  CreateModalStep.FormatAndRecipients,
  CreateModalStep.Summary,
];

export const getStepAttributes = (step: CreateModalStep, i18n: I18n) => {
  const translations = {
    [CreateModalStep.DevicesAndMetrics]: {
      title: t(i18n)`Dispositivos y métricas`,
    },
    [CreateModalStep.TimePeriod]: {
      title: t(i18n)`Periodos de tiempo`,
    },
    [CreateModalStep.FormatAndRecipients]: {
      title: t(i18n)`Formato y Destinatarios`,
    },
    [CreateModalStep.Summary]: {
      title: t(i18n)`Resumen general`,
    },
  };

  return translations[step];
};
